import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='settings' />
}

const skin = era.skin('routes/settings/root')

SettingsPage.displayName = 'SettingsPage'
export function SettingsPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='settingsTitle' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
